<template>
  <div id="page1">


    <!-- 移动端 -->
    <div v-if="!isPc">
      <div class="title">精选日记</div>
      <div class=" pad10" style="column-count: 2;column-gap: 0;">
        <div class="diaryBox" v-for="item in list" style="　height:100%;overflow:auto;">
          <div class="imgBox" v-on:click="toDetail(item.id)">
            <img :src="item.src" class="imgFit"/>
          </div>
         <div class="sepLine"></div>
          <div class="twoLine intro">{{item.text}}</div>
          <div class="d-flex align-items-center justify-content-between bottomBox" style="margin-top:10px">
            <div class="nickDiv d-flex align-items-center">
              <img  :src="item.headUrl" />
              <p>{{item.nickname}}</p>
            </div>
            <div class="lookDiv d-flex align-items-center">
              <img src="https://image.xingqubaike.com:8443/minicard/interest/eye.png" />
              <p>{{item.lookNum}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center lookMore" v-on:click="lookMore(layerShow)">查看更多 </div>
      <div class="layer d-flex flex-column align-items-center justify-content-center" v-if="layerShow">
        <div class="miniProjectImgBox d-flex flex-column justify-content-center align-items-center bgc-ffffff">
          <img src='../../assets/img/index/miniProjectImg.jpg' class="miniProjectImg"/>
          <div>微信扫码，查看更多精彩</div>
        </div>

        <img src='../../assets/img/index/close.png' class="closeImg" v-on:click="lookMore(layerShow)"/>
      </div>
    </div>

    <!-- pc端 -->
    <div v-if="isPc">
      <div class="page d-flex flex-column" >
        <v-header></v-header>
      	<div class="flex-fill ">
      		<div class="d-flex align-items-center mar-top20">
      			<div class="d-flex" style="margin-left:33%;">
      				<div class="videobox d-flex align-items-center justify-content-center">
      					<video width="300px" autoplay="autoplay" muted="muted" src="../../assets/video/index/showVideo.mp4" preload="auto" loop="loop" ></video>
      				</div>
      				<div class="iphone-bg d-flex align-items-center justify-content-center"></div>
      			</div>
      			<div class="mar-left50">
      				<h1 class="c-ffffff">兴趣百科</h1>
      				<div class="fz22 font-weight-bold c-ffffff">培养您的兴趣爱好</div>
      				<div class="fz22 font-weight-bold mar-top10 c-ffffff">迈向成功的殿堂！</div>
      				<img src="../../assets/img/index/miniProjectImg.jpg" style="width:180px;height:180;border-radius:10px" class="border2 mar-top20">
      				<div style="margin-top:20px;" class="c-ffffff">请使用微信扫码了解更多</div>
      			</div>
      		</div>
      	</div>

        <v-footer></v-footer>
      </div>
    </div>





  </div>

</template>

<script>
 import axios from "axios";
 import header from '@/pages/pc/header';
 import footer from '@/pages/pc/footer';
export default {
  name: 'HelloWorld',
  components:{
    'v-header':header,
    'v-footer':footer
  },
  data () {
    return {
      list: [],//日记列表
      layerShow:false,//弹窗层是否显示
      isPc:true,//是否是pc端
    }
  },
  mounted(){//页面加载后，调用接口数据
    //this.IsPc();//查看访问来源
    this.getData();

  },
  methods:{
    lookMore:function(param){//点击查看更多方法
      this.layerShow=!param
    },

    toDetail:function(id){//点击日记跳转到详情页
      this.$router.push({ name: 'detail',params:{id:id,name:'yx'}})
    },

    //获取数据列表
    getData:function(){
      var data = {}
      axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/home/official/getDiaryList',data).then(response => {
          this.list=response.data.result.list
      }, response => {
          console.log("error");
      });
    },

      //判断是手机端还是移动端
     IsPc:function(){
         if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {//苹果
             this.isPc=false;
         } else if (/(Android)/i.test(navigator.userAgent)) {//安卓
             this.isPc=false;
         } else {//pc
             this.isPc=true;
         }
      },



  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  //@import "../../static/css/common.css"; 直接在需要对应的vue中使用es6进行引入
  /************************************ 引动端样式 ***************************************/
  .pad10{
    padding:10px
  }

  .title{
     font-size:30px;
     font-weight:bolder;
     color:#333333;
     margin:20px 0 0 20px
  }

  .diaryBox{
    width:355px;
    border:1px solid #d1d1d1;
    border-radius:10px;
    padding-bottom:10px;
    margin-bottom:10px;
  }

  .imgBox{
    width:355px;
    height:355px;
    border-radius:10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .imgBox>img{
    width:355px;
    height:355px;
    border-radius:10px 10px 0 0;
  }


  .intro{
    padding:0 10px;
    font-size:20px;
    margin-top:10px
  }

  .lookDiv img{
    width:32px;
    height:32px
  }

  .nickDiv img{
    width:50px;
    height:50px;
    border-radius:50%
  }

  .nickDiv p,.lookDiv p{margin-left:5px;font-size:16px}

  .bottomBox{
    padding:0 10px;
  }

  .sepLine{
    width:355px;
    height:10px;
    background:#f1f1f1;
  }

  .lookMore{
    padding:30px 0 50px 0
  }

  .layer{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position: fixed;
    top:0;
    left:0;
    z-index: 10;
  }

  .miniProjectImgBox{
    width:400px;
    height:400px;
    border-radius: 10px;
  }

  .miniProjectImgBox div{
    margin-top:10px
  }

  .miniProjectImg{
    width:300px;
    height:300px;
  }

  .closeImg{
    width:80px;
    height:80px;
    margin-top:25px
  }



  /****************************************pc端样式*************************************/
  //@import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  #page1 #header{background:none}
  #page1 #header a{color:#fff}
  #page1 #footer a{color:#fff}
</style>



// WEBPACK FOOTER //
// src/pages/index/HelloWorld.vue